import "../styles/branches.css";
import axios from "axios";
import { useEffect, useState } from "react";
import { TextInput } from "../Components/TextInput";
import SideFormWrapper from "../Components/SideFormWrapper";

export default function Branches() {
  const [branches, setBranches] = useState([]);
  const [formState, setFormState] = useState(false);
  const [formData, setFormData] = useState(null);

  const AddBranchForm = () => {
    return (
      <form
        method="POST"
        onClick={(e) => {
          e.stopPropagation();
        }}
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit(e);
        }}
      >
        <TextInput
          name={"location"}
          label={"Location"}
          data={formData?.location || ""}
        />
        <TextInput
          name={"manager"}
          label={"Manager"}
          data={formData?.manager || ""}
        />

        <select name="status" defaultValue={formData?.status || ""}>
          <option value={"0"}>Choose Status</option>
          <option value={"active"}>Active</option>
          <option value={"inactive"}>InActive</option>
        </select>

        <section className="btns-section">
          <button>Confirm</button>
          <button
            id="cancel-btn"
            onClick={(e) => {
              toggleForm(false);
            }}
          >
            Cancel
          </button>
        </section>
      </form>
    );
  };
  const toggleForm = (flag, edit = false, data = null) => {
    if (edit) {
      setFormData(data);
    }
    if (!flag) {
      setFormData(null);
    }
    setFormState(flag);
  };

  function handleSubmit(e, edit = false) {
    const formData_main = new FormData(e.target);
    const data = Object.fromEntries(formData_main.entries());

    if (!formData) {
      axios
        .post(`${process.env.REACT_APP_LOCAL_API_URL}/admin/branches`, { data })
        .then((res) => {
          const { error } = res.data;
          if (!error) {
            setFormData(null);
            toggleForm(false);
          }
        });
    } else {
      axios
        .put(`${process.env.REACT_APP_LOCAL_API_URL}/admin/branches`, {
          id: formData.id,
          data,
        })
        .then((res) => {
          const { error } = res.data;
          if (!error) {
            setFormData(null);
            toggleForm(false);
          }
        })
        .catch((err) => {
          alert(err);
        });
    }
  }

  function handleDelete(data) {
    axios
      .delete(`${process.env.REACT_APP_LOCAL_API_URL}/admin/branches`, { data })
      .then((res) => {
        console.log(res.data);
        window.location.reload();
      })
      .catch((err) => {
        alert("Error deleting data");
        console.log("error" + err.message);
      });
  }
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_LOCAL_API_URL}/admin/branches`)
      .then((res) => {
        console.log(res);
        setBranches(res.data);
      })
      .catch((err) => {
        console.log("error" + err.message);
      });
  }, [formData]);
  return (
    <>
      {formState && (
        <SideFormWrapper children={<AddBranchForm />} toggleForm={toggleForm} />
      )}
      <section className="page-title-section">
        <h1>Branches</h1>
        <button
          className="btn"
          onClick={(e) => {
            toggleForm(true);
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-building-fill-add"
            viewBox="0 0 16 16"
          >
            <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0" />
            <path d="M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v7.256A4.5 4.5 0 0 0 12.5 8a4.5 4.5 0 0 0-3.59 1.787A.5.5 0 0 0 9 9.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .39-.187A4.5 4.5 0 0 0 8.027 12H6.5a.5.5 0 0 0-.5.5V16H3a1 1 0 0 1-1-1zm2 1.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5m3 0v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5m3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zM4 5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5M7.5 5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm2.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5M4.5 8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z" />
          </svg>
          Add Branch
        </button>
      </section>
      <table className="branches-table">
        <thead>
          <tr>
            <th>Location</th>
            <th>Status</th>
            <th>Manager</th>
            <th>Created At</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {branches.map((branch) => (
            <tr key={branch.id}>
              <td>{branch.location}</td>
              <td>
                <span className={`status ${branch.status.toLowerCase()}`}>
                  {branch.status}
                </span>
              </td>
              <td>{branch.manager}</td>
              <td>{branch.created_at.split("T")[0]}</td>
              <td className="action-btn-wrapper">
                <button className="action-btn" id="generateQrBtn">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    class="bi bi-qr-code-scan"
                    viewBox="0 0 16 16"
                  >
                    <path d="M0 .5A.5.5 0 0 1 .5 0h3a.5.5 0 0 1 0 1H1v2.5a.5.5 0 0 1-1 0zm12 0a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0V1h-2.5a.5.5 0 0 1-.5-.5M.5 12a.5.5 0 0 1 .5.5V15h2.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5m15 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1H15v-2.5a.5.5 0 0 1 .5-.5M4 4h1v1H4z" />
                    <path d="M7 2H2v5h5zM3 3h3v3H3zm2 8H4v1h1z" />
                    <path d="M7 9H2v5h5zm-4 1h3v3H3zm8-6h1v1h-1z" />
                    <path d="M9 2h5v5H9zm1 1v3h3V3zM8 8v2h1v1H8v1h2v-2h1v2h1v-1h2v-1h-3V8zm2 2H9V9h1zm4 2h-1v1h-2v1h3zm-4 2v-1H8v1z" />
                    <path d="M12 9h2V8h-2z" />
                  </svg>
                </button>
                <button
                  id="edit-btn"
                  className="action-btn"
                  onClick={(e) => {
                    toggleForm(true, true, {
                      id: branch.id,
                      location: branch.location,
                      status: branch.status,
                      manager: branch.manager,
                    });
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-pencil-square"
                    viewBox="0 0 16 16"
                  >
                    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                    <path
                      fillRule="evenodd"
                      d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                    />
                  </svg>
                </button>
                <button
                  id="del-btn"
                  className="action-btn"
                  onClick={(e) => {
                    e.preventDefault();
                    handleDelete({
                      id: branch.id,
                      location: branch.location,
                      status: branch.status,
                      manager: branch.manager,
                    });
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-trash"
                    viewBox="0 0 16 16"
                  >
                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                    <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                  </svg>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}
